import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-60a7a01a"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "accordion-container"
};
var _hoisted_2 = ["onClick", "onMouseenter", "onMouseleave"];
var _hoisted_3 = {
  class: "slide-handler"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reactiveList, function (item) {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["slide-container", {
        active: item.active
      }]),
      key: item.id,
      onClick: function ($event) {
        return _ctx.onClickSlide(item);
      },
      onMouseenter: function ($event) {
        return _ctx.onMouseEnter(item);
      },
      onMouseleave: function ($event) {
        return _ctx.onMouseLeave(item);
      },
      style: _normalizeStyle("width:".concat(_ctx.gap, "px;flex:0 0 ").concat(_ctx.gap, "px;background-image: url(").concat(item.image, ")"))
    }, [_createElementVNode("div", _hoisted_3, _toDisplayString(item.id), 1)], 46, _hoisted_2);
  }), 128))]);
}